import React, { useEffect, useState } from "react";
import "../Components/Modal.css";
import modallogo from "../Assets/Images/Homepage/modal-logo.png";

const TestimonialModal = ({ isOpen, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem("modalDismissed", "true");
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div
      className={`modalBackdrop ${isVisible ? "is-open" : ""}`}
      onClick={handleClose}
    >
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="closeBtn">
          <button onClick={handleClose}>&times;</button>
        </div>
        <div className="modalContainer">
          <h3>Share Your Experience with Us!</h3>
          <p>
            We'd love to hear from you! Share your feedback or leave a review to
            help us continue providing excellent service.
          </p>
          <div className="modalButtom">
            <button>
              <a href="https://g.page/r/CWxwm92LW980EBM/review">
                Write a Review
              </a>
            </button>
            <img src={modallogo} alt="modal_icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialModal;
